import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62ed76e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = {
  key: 0,
  class: "col-md-12 result-pane",
  ref: "resultpane"
}
const _hoisted_3 = {
  key: 1,
  class: "col-md-12 result-pane"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "lead text-center align-middle" }, "No bookings found", -1))
const _hoisted_5 = [
  _hoisted_4
]

import { ref, computed, inject, onMounted, onBeforeUnmount, onUnmounted, } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import { useEvent } from '@/eventBus';
import { Booking } from "@/models";
import SubJobModal from "@/components/modals/SubJobModal.vue";
import PersonalJobModal from "@/components/modals/PersonalJobModal.vue";
import ManagementResultTemplate from "./ManagementResultTemplate.vue";
import Ably from "ably";
import AlertDialog from "@/components/modals/AlertDialog.vue";
import { debounce } from "lodash";
import BookingDetailModal from "@/components/modals/BookingDetailModal.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'ManagementResults',
  props: {
    results: {},
    futurebookingid: {}
  },
  emits: ['selectgooglebooking', 'selectbooking', 'removebookingfromlocal'],
  setup(__props: any, { emit: __emit }) {

const realtime: Ably.Realtime = inject('realtime');
const actProperty: any = inject('actProperty');
const channel = realtime.channels.get('diary');
const deviceid = actProperty.getDeviceId();

// Props
const props = __props;

const emit = __emit;

// Store access
const store = useStore();
const router = useRouter();
const route = useRoute();


// Data
const selectedbookingid = ref('');
const selectedsubjob = ref(new Booking());
const unsavedchangesonform = ref(false);
const subJobModal = ref(null);
const personalJobModal = ref(null);
const alertDialog = ref(null);
const bookingDetailModal = ref(null);

// Computed properties and getters
const selectedbooking = ref(new Booking());
const clickTimer = ref<ReturnType<typeof setTimeout> | null>(null);
const email = computed(() => store.getters['auth/email']);

// Methods
const getBooking = (id: string): Promise<Booking> => {
  return store.dispatch('diary/getBooking', id);
};

const isfocused = (b: Booking) => {
  if (b?.id) {
    if (selectedbookingid.value) {
      return b.id === selectedbookingid.value;
    }
    // else if (props.futurebookingid) {
    //   return b.id === props.futurebookingid;
    // }
  }
  return false;
};
// Events handling
onMounted(() => {
  useEvent("appointmentRestoredInBookingTemplate", (booking: any) => {
    let index = props.results.findIndex((b: Booking) => b.id === booking.id);
    if (index >= 0) {
      // eslint-disable-next-line vue/no-mutating-props
      props.results.splice(index, 1);
    }
  });
  useEvent("appointmentChangedInBookingTemplate", (booking: any) => {
    let index = props.results.findIndex((b: Booking) => b.id === booking.id);
    if (index >= 0) {
      // eslint-disable-next-line vue/no-mutating-props
      props.results.splice(index, 1);
      // eslint-disable-next-line vue/no-mutating-props
      props.results.push(booking);
    }
  });
  channel.subscribe('unsavedChangesOnFormForExistingBooking', (message: any) => {
    if (message?.data) {
      if (message.data.deviceid != deviceid) return;
      selectedbookingid.value = message.data.bookingid;
      showUnsavedChangesAlert('There are unsaved changes on the open booking form. Please first save all the changes to load the selected booking');
    }
  });

  channel.subscribe('unsavedChangesOnFormForNewBooking', (message: any) => {
    if (message?.data) {
      if (message.data.deviceid != deviceid) return;
      selectedbookingid.value = message.data.bookingid;
      showUnsavedChangesAlert('There are unsaved changes on the open booking form. Please first save all the changes before starting a new booking');
    }
  });
  channel.subscribe('appointmentLoading', (message: any) => {
  if (message?.data) {
    if (message.data.deviceid != deviceid) return;
    if (!message.data.cancelled) {
      // If it is not a cancelled booking, highlight
      selectedbookingid.value = message.data.bookingid;
    }
    else {
      // If it is a cancelled booking, don't highlight, just set the selectedbookingid
      // so that the 2 second timeout does not open another tab
      selectedbookingid.value = message.data.bookingid;
    }
  }
});
});

onBeforeUnmount(() => {
  channel.unsubscribe('unsavedChangesOnFormForExistingBooking');
  channel.unsubscribe('unsavedChangesOnFormForNewBooking');
  channel.unsubscribe('appointmentLoading');
});

const showUnsavedChangesAlert = (message: string) => {
  const modal = alertDialog.value as any;
  if (modal) {
    modal.init(
      'Warning',
      message,
      'Ok'
    );
    modal.show();
  }
}

const selectbooking = async (booking: Booking) => {
  if (booking.id && !booking.locked || (booking.locked && booking.lockedby === email.value)) {
    if (booking.googleid) {
      // Assuming $emit is available in the setup context
      selectedbookingid.value = booking.id;
      emit("selectgooglebooking", booking);
    } else if (!booking.subtype) {
      channel.publish('appointmentSelected',
        {
          deviceid: deviceid,
          bookingid: booking.id,
          inspectorid: booking.inspector?.id,
          googleid: booking.googleid,
          subtype: booking.subtype,
          jobtype: booking.jobtype,
          bookingdate: booking.bookingdate,
        });
      channel.publish('locateBooking', { deviceid: deviceid, bookingid: booking.id, date: booking.startdate });
      channel.publish('appointmentSelectedOnManagementFilters', { deviceid: deviceid, bookingid: booking.id });
      unsavedchangesonform.value = false;
      emit('selectbooking', booking);
      try {
        const fetchedBooking = await getBooking(booking.id);
        if (fetchedBooking === undefined) {
          actProperty.displayError(`Could not find booking with ID ${route.params.id}`);
          router.push({ name: "newbooking" });
        }
      } catch (err) {
        actProperty.displayError(err);
      }
      selectedbooking.value = booking;
      // Wait for 2 seconds, to check if there is form open on another tab and the appointment loaded
      setTimeout(() => {
        if (selectedbooking.value.id != selectedbookingid.value) {
          window.open(`/diary/${selectedbooking.value.id}`, '_blank');
          selectedbookingid.value = booking.id;
        }
      }, 2000);
      if (unsavedchangesonform.value) {
        selectedbookingid.value = '';
        unsavedchangesonform.value = false;
      }
    }
  }
};

const removebookingfromlocal = (booking: Booking) => {
  emit("removebookingfromlocal", booking);
}

const handleClick = (booking: any) => {
  if (booking.subtype === 'Prep' || booking.subtype === 'Key') {
    singleClickOrSubbooking(booking);
  }
  else if (clickTimer.value) {
    clearTimeout(clickTimer.value);
    clickTimer.value = null;
    selectbooking(booking);
  } else {
    singleClickOrSubbooking(booking);
  }
}

const singleClickOrSubbooking = (booking: Booking) => {
  clickTimer.value = setTimeout(async () => {
    const fetchedBooking = await getBooking(booking.id);
    if (fetchedBooking === undefined) {
      actProperty.displayError(`Could not find booking with ID ${route.params.id}`);
    }
    singleAppointmentClick(fetchedBooking);
    clearTimeout(clickTimer.value as ReturnType<typeof setTimeout>);
    clickTimer.value = null;
  }, 300); // 300 ms delay to distinguish between single and double clicks
}

const singleAppointmentClick = (booking: Booking) => {
  if (booking && booking?.subtype != Booking.PERSONAL) {
    const modal = bookingDetailModal.value as any;
    modal.init(booking);
    modal.show();
  }
}
const handleDoubleClick = (event: MouseEvent) => {
  // Prevent the default double click behavior
  event.preventDefault();
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.results && _ctx.results.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results, (booking) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["col-md-12 pt-2 pb-2", {
      'selected-booking':
        (booking.id && selectedbooking.value.id && booking.id === selectedbooking.value.id) ||
        (booking.googleid && selectedbooking.value.googleid && booking.googleid === selectedbooking.value.googleid),
      'cancelled-booking': booking.cancelled,
      'focused-booking': isfocused(booking)
    }]),
              key: booking.id
            }, [
              _createVNode(ManagementResultTemplate, {
                onClick: ($event: any) => (handleClick(booking)),
                onDblclick: _withModifiers(handleDoubleClick, ["prevent"]),
                templateModel: { appointmentData: booking },
                picolour: false,
                rightclick: false,
                showdate: true,
                style: {"overflow-y":"hidden"},
                onRemovebookingfromlocal: removebookingfromlocal
              }, null, 8, ["onClick", "templateModel"])
            ], 2))
          }), 128))
        ], 512))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5)),
    _createVNode(AlertDialog, {
      ref_key: "alertDialog",
      ref: alertDialog,
      name: "scalertdialog"
    }, null, 512),
    _createVNode(SubJobModal, {
      ref_key: "subJobModal",
      ref: subJobModal,
      id: "management-results-subjob-modal"
    }, null, 512),
    _createVNode(PersonalJobModal, {
      id: "manage-personal-job-modal",
      ref_key: "personalJobModal",
      ref: personalJobModal,
      booking: selectedsubjob.value
    }, null, 8, ["booking"]),
    _createVNode(BookingDetailModal, {
      id: "schedular-booking-detail-model",
      ref_key: "bookingDetailModal",
      ref: bookingDetailModal
    }, null, 512)
  ]))
}
}

})